module.exports = __webpack_public_path__ + "media/img/front_wheel-0b96c265.svg";